import * as Styles from './LedRing.styles'

export function LedRing() {
  const ledCount = 24

  return (
    <Styles.LedRingContainer>
      {Array.from({ length: ledCount }).map((_, index) => {
        const angle = (360 / ledCount) * index

        return (
          <Styles.LedWrapper key={index} angle={angle}>
            <Styles.Led className={index % 2 === 0 ? 'ledEven' : 'ledOdd'} />
          </Styles.LedWrapper>
        )
      })}
    </Styles.LedRingContainer>
  )
}
